var $eb82ef981b5592bf$exports = {};
$eb82ef981b5592bf$exports = {
  "calendar": `Calendar`,
  "day": `zi`,
  "dayPeriod": `a.m/p.m.`,
  "endDate": `Dat\u{103} final`,
  "era": `er\u{103}`,
  "hour": `or\u{103}`,
  "minute": `minut`,
  "month": `lun\u{103}`,
  "second": `secund\u{103}`,
  "selectedDateDescription": args => `Dat\u{103} selectat\u{103}: ${args.date}`,
  "selectedRangeDescription": args => `Interval selectat: de la ${args.startDate} p\xe2n\u{103} la ${args.endDate}`,
  "selectedTimeDescription": args => `Ora selectat\u{103}: ${args.time}`,
  "startDate": `Dat\u{103} \xeenceput`,
  "timeZoneName": `fus orar`,
  "weekday": `ziua din s\u{103}pt\u{103}m\xe2n\u{103}`,
  "year": `an`
};
export { $eb82ef981b5592bf$exports as default };